<template>
  <section class="personal-informations">
    <div class="personal-informations__img-wrapper">
      <div class="personal-informations__img">
        <img src="" />
      </div>
    </div>

    <div class="personal-informations__data-container">
      <h1 class="personal-informations__name">
        {{ personalData.first_name }} {{ personalData.last_name }}
        <v-chip
          v-if="personalData.is_verified"
          class="personal-informations__verified"
          label
        >
          <v-icon small left>mdi-shield-check</v-icon>
          Verified
        </v-chip>
      </h1>

      <v-row>
        <v-col class="col-12 col-md-6 py-0">
          <div class="personal-informations__dev-info">
            <p class="personal-informations__text-line">
              <b>{{ personalData.level }}</b>
            </p>
            <p
              v-if="personalData.experience_in_years"
              class="personal-informations__text-line"
            >
              <b>{{ personalData.experience_in_years }} years experience</b>
            </p>
          </div>

          <div class="personal-informations__contact-info">
            <p v-if="personalData.city" class="personal-informations__text-line">
              <b>{{ personalData.city }}</b>
            </p>
            <p v-if="personalData.nationality" class="personal-informations__text-line">
              {{ personalData.nationality }}
            </p>
            <p v-if="personalData.birthdate" class="personal-informations__text-line">
              {{ personalData.birthdate | displayDate }}
            </p>
            <p v-if="personalData.phone_number" class="personal-informations__text-line">
              {{ personalData.phone_number }}
            </p>
            <p v-if="personalData.email" class="personal-informations__text-line">
              <a :href="`mailto:${personalData.email}`" class="blue--text">
                {{ personalData.email }}
              </a>
            </p>
          </div>
        </v-col>

        <v-col class="col-12 col-md-6 py-0">
          <template v-if="personalData.software_house && personalData.software_house.name">
            <p v-if="personalData.software_house.name"
              class="personal-informations__line mt-2 mt-md-0"
            >
              <v-icon medium color="blue">mdi-domain</v-icon>
              <span class="ml-3"><b>{{ personalData.software_house.name }}</b></span>
            </p>
            <div class="personal-informations__softwarehouse-info">
              <p class="mb-0">Contact PM</p>

              <p v-if="personalData.software_house.pm_first_name"
                class="body-2 mb-0"
              >
                <b>{{ personalData.software_house.pm_first_name }}&nbsp;
                {{ personalData.software_house.pm_last_name }}</b>
              </p>

              <p v-if="personalData.software_house.pm_email"
                class="mb-0"
              >
                {{ personalData.software_house.pm_email }}
              </p>

              <p v-if="personalData.software_house.pm_phone_number"
                class="mb-0"
              >
                {{ personalData.software_house.pm_phone_number }}
              </p>
            </div>
          </template>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div class="personal-informations__socials">
            <SocialLink
              v-if="personalData.linkedin_link"
              :link="personalData.linkedin_link"
              color="red"
              icon="mdi-linkedin" />

            <SocialLink
              v-if="personalData.git_link"
              :link="personalData.git_link"
              color="orange"
              icon="mdi-github-circle" />

            <SocialLink
              v-if="personalData.skype_link"
              :link="personalData.skype_link"
              color="blue"
              icon="mdi-skype" />
          </div>
        </v-col>
      </v-row>
    </div>

  </section>
</template>

<script>
import SocialLink from '@/components/Developers/Show/SocialLink.vue';

export default {
  components: {
    SocialLink,
  },

  props: {
    personalData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-informations {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;

  @include tablet {
    flex-direction: row;
  }

  &__img {
    width: 160px;
    height: 160px;
    flex: 0 0 160px;
    background: $color--secondary;
    border-radius: 8px;
    margin: 0 auto;
  }

  &__verified {
    margin-left: 16px;
  }

  &__data-container {
    margin-left: 24px;
    flex-grow: 1;
  }

  &__name {
    display: flex;
    align-items: center;
    font-size: 28px;
    line-height: 28px;
    margin-bottom: 8px;
    word-break: break-all;
  }

  &__line {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  &__dev-info {
    border-left: 5px solid $color--blue;
    font-size: 14px;
    line-height: 16px;
    padding-left: 16px;
  }

  &__contact-info {
    border-left: 5px solid $color--blue;
    font-size: 14px;
    line-height: 16px;
    padding-left: 16px;
    margin-top: 8px;
  }

  &__text-line {
    margin-bottom: 2px;
  }

  &__softwarehouse-info {
    border-left: 5px solid $color--blue;
    font-size: 12px;
    line-height: 16px;
    padding-left: 16px;
  }

  &__socials {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 100%;

    @include tablet {
      justify-content: flex-end;
    }
  }
}
</style>
